import AppRouter from './routes/AppRoute';
import { Providers } from './provider';
import { useEffect } from 'react';

const App = () => {
  useEffect(() => {
    const checkForUpdates = async () => {
      try {
        const res = await fetch('/meta.json', {
          cache: 'no-cache',
          headers: {
            'Accept': 'application/json'
          }
        });
        const meta = await res.json();

        const currentVersion = localStorage.getItem('spa_version');

        if (meta.version !== currentVersion) {
          localStorage.setItem('spa_version', meta.version);

          console.log('New SPA version available, reloading...');
          window.location.reload();
        }
      } catch (err) {
        console.warn('Got error while checking SPA version:', err);
      }
    };

    checkForUpdates(); // at start
    const interval = setInterval(checkForUpdates, 30000); // every 30 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <Providers>
      <AppRouter />
    </Providers>
  );
};

export default App;
